import { Box, Grid } from '@mui/material';

const style = {
  minHeight: '4rem',
  bgcolor: '#2C313D',
  borderRadius: '5px',
  boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px',
  mb: 3,
  display: 'flex',
  px: 2,
  py: 1,
};

export const QueryContainer = (props) => {
  return (
    <Box sx={style}>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        {props.children}
      </Grid>
    </Box>
  );
};
